import request from '@/utils/request'
// import qs from 'qs'

// 报警跟踪相关的接口写在这里

// 获取跟踪详情 需要传入报警信息的id
export function alarmTracking(token, query) {
	return request({
		url: '/api/alarmTrack/findTrack?id=' + query,
		method: 'get',
		// params: query,
		headers: {
			Authorization: token
		}
	})
}

export function ImageGetURL(token, query) {
	return request({
		url: '/api/alarmTrack/getURL?id=' + query,
		method: 'get',
		// params: query,
		headers: {
			Authorization: token
		}
	})
}

// http://iot.lituo119.com/app  用户列表  /member/queryUserListForDL

export function queryUserListForDL(token, query) {
	return request({
		url: '/api/member/queryUserListForDL',
		method: 'get',
		params: query,
		headers: {
			Authorization: token
		}
	})
}
// patrolFile/getPatrolFileByUserId
export function getPatrolFileByUserId(token) {
	return request({
		url: '/api/patrolFile/getPatrolFileByUserId',
		method: 'get',
		headers: {
			Authorization: token
		}
	})
}
// /api/patrolFile/download
export function downloadOne(token, fileName, id) {
	return request({
		url: '/api/patrolFile/download?id=' + id + '&fileName=' + fileName,
		method: 'post',
		responseType: 'blob',
		headers: {
			Authorization: token
		},
		data: {
			// id:id,
			// fileName:fileName
		}
	})
}
// /api/patrolFile/deletePatrolFileById
export function deletePatrolFileById(token, id) {
	return request({
		url: `/api/patrolFile/deletePatrolFileById?id=${id}`,
		method: 'POST',
		headers: {
			Authorization: token
		}
	})
}


// assess/queryWbInfo
export function queryWbInfo(token, custId) {
	return request({
		url: `/api/assess/queryWbInfo?custId=${custId}`,
		method: 'GET',
		headers: {
			Authorization: token
		}
	})
}

// 主体重置用户密码
// /member/resetPasswordByZT?userId=CHYGSFSS&password=CHYGSFSS&confirmPassword=CHYGSFSS
// export function resetPasswordByZT()
export function memberResetPasswordByZT({userId ,password ,confirmPassword }) {
	return request({
		url: `/api/member/resetPasswordByZT?userId=${userId}&password=${password}&confirmPassword=${confirmPassword}`,
		method: 'PUT',
		// data,
		// data:JSON.stringify(data),
		headers: {
			'content-type': 'application/json'
		}
		
	})
}



// 主体更新用户名称
// /member/updateUserNameByZT?userId=C999&userName=C999

export function memberUpdateUserNameByZT({userId , userName}) {
	return request({
		url: `/api/member/updateUserNameByZT?userId=${userId}&userName=${userName}`,
		method: 'PUT',
		// data,
		// data:JSON.stringify(data),
		headers: {
			'content-type': 'application/json'
		}
	})
}
// 改变用户状态 停用/启用
export function updateUserStatus(data) {
	return request({
		method: 'get',
		url: '/api/user/updateUserStatus',
		params:data
	})
}
// 重置用户设备信息
export function delDeviceInfo(data) {
	return request({
		method: 'post',
		url: '/api/user/delDeviceInfo',
		data:data
	})
}